var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "validator_pagination_control"
  }, [_c('button', {
    class: {
      disabled: _vm.page === 1
    },
    on: {
      "click": function click($event) {
        _vm.page = 1;
      }
    }
  }, [_vm._v(" First ")]), _c('button', {
    class: {
      disabled: _vm.page === 1
    },
    on: {
      "click": _vm.pageDown
    }
  }, [_vm._v(" < ")]), _c('p', {
    staticClass: "pages"
  }, [_vm._v(" Page "), _c('b', [_vm._v(_vm._s(_vm.page))]), _vm._v(" of "), _c('b', [_vm._v(_vm._s(_vm.totalPages))])]), _c('button', {
    class: {
      disabled: _vm.page === _vm.totalPages
    },
    on: {
      "click": _vm.pageUp
    }
  }, [_vm._v(" > ")]), _c('button', {
    class: {
      disabled: _vm.page === _vm.totalPages
    },
    on: {
      "click": function click($event) {
        _vm.page = _vm.totalPages;
      }
    }
  }, [_vm._v(" Last ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }